/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button } from "../../../../../components/Component";
const ButtonDisableER = ({ ...props }) => {
    const [Count, setCount] = useState(0);
    const [isShown, setIsShown] = useState(false);
    const changepage = async (id) => {
        const sendData = {
            CatgTypeId: Number(id),

        }
     /*   //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    localStorage.setItem('userId', data.userId)
                    window.location.pathname = "/ERdashboard"
                    /*props.history.push("/Dashboard")*/
                })


    };



    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            MonthId: Number(props.month),
            Month: String(props.catgtype),
        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/' + props.api, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                  /*  //console.log(data)*/
                    setCount(data)
                })


    };

    useEffect(() => {
        getdata()
    }, [])


    return (
        <>{Count.edit + Count.submit !== 0 ? props.api ==="DgecountER"?
            <td><Button color="primary" onClick={() => (sessionStorage.setItem("StateER", props.catgtype), window.location.pathname = "/ERStatedashboard")}>View <em class="icon ni ni-eye-fill"></em></Button> </td> :
            props.api === "StatecountER" ?
                <td><Button color="primary" onClick={() => (sessionStorage.setItem("RegionER", props.catgtype), window.location.pathname ="/ERRegionaldashboard")}>View <em class="icon ni ni-eye-fill"></em></Button> </td> :
            <td><Button color="primary" onClick={() => changepage(props.catgtype)}>View <em class="icon ni ni-eye-fill"></em></Button> </td>
            : <td><Button color="danger" disabled onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>{!isShown ? "View" : null}{isShown && (
                <div>
                    You cannot View this page.
                </div>
            )} <em class="icon ni ni-eye-fill"></em></Button> </td>}
            

        </>
    )
};

export default ButtonDisableER;
